var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.fetchingBucket)?_c('loading-page'):(_vm.somethingWentWrong)?_c('div',[_vm._v(" Something went wrong. Please try again later. ")]):(_vm.bucket)?_c('bucket-form'):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }